import { EWidgetMode } from '../../../../types/redux/layout';

export const getApplyButtonText = (mode: EWidgetMode): string => {
  return mode === EWidgetMode.Payment ? 'Оплатить' : 'Пополнить';
};
